import { useAuth } from './use-auth'
import { useSubscription } from './use-subscription'

const hooks = { useAuth, useSubscription }

export default hooks
